export const checkautoBikeKey = 'checkautoBikeKey';
export const checkautoCarKey = 'checkautoCarKey';
export const checkautoCommercialKey = 'checkautoCommercialKey';
export const companySearchKey = 'companySearch';
export const partsSearchKey = 'partsSearch';
export const placementSearchKey = 'placementSearch';
export const servicesSearchKey = 'servicesSearch';
export const rentSearchKey = 'rentSearch';
export const bikeSearchKey = 'bikeSearch';
export const carSearchKey = 'carSearch';
export const commercialSearchKey = 'commercialSearch';
export const sortedKey = 'sorted';
export const searchCountKey = 'searchCount';
